import React from 'react';
import { menuIcon } from '../../../../../configs/Icons';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import Button from '../../../../utils/Button';
import { GetNumberWithComma } from '../../../../utils/NumberFormatter';
import { GetDate } from '../../../../utils/Show';
import cn from '../../../../utils/cn';
import { handleUnlinkGithubRepoWithAppOpe } from '../SubscriptionsDetailsOpe';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';

export function LinkWithGithubCard({ onClick, className, data }) {
    const { setReloadKey } = useSubscriptionsDetails();
    const { setMessage, setConfirm, setTemplateLoading } = useTemplate();
    const handleUnlink = (e, id) => {
        e.stopPropagation();
        setConfirm({
            text: 'Are you sure you want to unlink this repository?',
            textAction: 'Unlink',
            clickAction: () => {
                setTemplateLoading(true);
                handleUnlinkGithubRepoWithAppOpe(id)
                    .then(({ title }) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        setReloadKey((prev) => prev + 1);
                    })
                    .catch((error) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'error', text: error.toString(0) });
                    });
            }
        });
    };

    return (
        <div
            className={`group w-full lg:w-[310px] min-h-[72px] flex flex-row rounded-xl bg-secondary p-3 transition-all ${className}`}
        >
            <div className="flex flex-col justify-between items-start w-full">
                <div className="flex flex-col justify-start  w-full">
                    <div className="flex justify-between ">
                        <div className="inline-block size-9 rounded-full overflow-hidden border border-primary-200">
                            <img
                                src={data.repository.owner.avatarUrl}
                                alt={data?.repository.fullName}
                                className="size-full object-cover object-center"
                            />
                        </div>
                        <div>
                            <button
                                type="button"
                                className="w-9 h-9 flex-1 bg-secondary-700 rounded-lg p-1 cursor-default"
                            >
                                <img src={menuIcon.settingsWF} alt="" className="w-full h-full" />
                            </button>
                        </div>
                    </div>
                    <div className="w-full text-sm font-medium  flex flex-col text-white mb-2">
                        <span className="line-clamp-1">
                            Full Name: {data?.repository?.fullName}
                        </span>
                        <span className="">
                            Privacy: {data?.repository?.private ? 'Private' : 'Public'}
                        </span>
                    </div>
                    <span className="w-full h-9 md:h-10 inline-flex gap-2">
                        <Button
                            title="View Releases"
                            onClick={onClick}
                            className="w-full h-full block bg-secondary-700 text-white hover:bg-white hover:text-secondary-700 transition-colors"
                        />
                        <Button
                            title="unlink"
                            onClick={(e) => handleUnlink(e, data.id)}
                            className="w-full h-full block bg-secondary-700 text-white hover:bg-white hover:text-secondary-700 transition-colors"
                        />
                    </span>
                </div>
            </div>
        </div>
    );
}
function LifeTimeCard({ /* onClick, */ data }) {
    return (
        <div
            className={cn(
                'group w-full lg:w-76 min-h-[72px] rounded-[15px] bg-secondary p-3 transition-all flex flex-col justify-between',
                {
                    'bg-primary-200': data.demo
                }
            )}
        >
            <div className="flex flex-row mb-2 justify-between">
                <div className="flex flex-col gap-2 justify-between items-start">
                    <h4 className="text-lg font-medium text-white mt-2">
                        <span>Lifetime</span>
                    </h4>

                    <div className="text-sm font-normal text-primary-50">
                        <span>
                            Support and Service Expired on{' '}
                            {GetDate(data.timeSubscriptionEnd) || '----'}
                        </span>
                    </div>
                </div>

                <div
                    className={`w-9 min-w-[36px] h-9 bg-secondary-700 rounded-lg p-1 ${
                        data?.demo ? 'hidden' : 'block'
                    }`}
                >
                    <img src={menuIcon.settingsWF} alt="" className="w-full h-full " />
                </div>
            </div>

            {/* <span className="w-full h-9 md:h-10 block">
                <Button
                    title="Buy Support & Service"
                    onClick={onClick}
                    className="w-full h-full bg-secondary-700 text-white hover:bg-white hover:text-secondary-700 transition-colors"
                />
            </span> */}
        </div>
    );
}
function PPUCard({ onClick, data }) {
    return (
        <div
            className={cn(
                'group w-full lg:w-76 min-h-[72px] rounded-[15px] bg-secondary p-3 transition-all flex flex-col justify-between',
                {
                    'bg-primary-200': data.demo
                }
            )}
        >
            <div className="flex flex-row mb-2 justify-between">
                <div className="flex flex-col gap-2 justify-between items-start">
                    <h4 className="text-lg font-medium text-white mt-2">
                        <span>PPU</span>
                    </h4>

                    <div className="text-sm font-normal text-primary-50">
                        <span>Your Remain PPU is {GetNumberWithComma(data.limitByValue || 0)}</span>
                    </div>
                </div>

                <div
                    className={`w-9 min-w-[36px] h-9 bg-secondary-700 rounded-lg p-1 ${
                        data?.demo ? 'hidden' : 'block'
                    }`}
                >
                    <img src={menuIcon.settingsWF} alt="" className="w-full h-full " />
                </div>
            </div>

            <span className="w-full h-9 md:h-10 block">
                <Button
                    title="Buy More PPU"
                    onClick={onClick}
                    className="w-full h-full block bg-secondary-700 text-white hover:bg-white hover:text-secondary-700 transition-colors"
                />
            </span>
        </div>
    );
}
function DurationCard({ onClick, data }) {
    return (
        <div
            className={cn(
                'group w-full lg:w-76 min-h-[72px] rounded-[15px] bg-secondary p-3 transition-all flex flex-col justify-between',
                {
                    'bg-primary-200': data.demo
                }
            )}
        >
            <div className="flex flex-row mb-2 justify-between">
                <div className="flex flex-col gap-2 justify-between items-start">
                    <h4 className="text-lg font-medium text-white mt-2">
                        <span>Subscription Validity</span>
                    </h4>

                    <div className="text-sm font-normal text-primary-50">
                        <span>
                            Your subscription is valid till{' '}
                            {GetDate(data.timeSubscriptionEnd) || '----'}
                        </span>
                    </div>
                </div>

                <div
                    className={`w-9 min-w-[36px] h-9 bg-secondary-700 rounded-lg p-1 ${
                        data?.demo ? 'hidden' : 'block'
                    }`}
                >
                    <img src={menuIcon.settingsWF} alt="" className="w-full h-full " />
                </div>
            </div>

            <span className="w-full h-9 md:h-10 block">
                {data.limitBy !== 'lifetime' && (
                    <Button
                        title="Renew"
                        onClick={onClick}
                        className="w-full h-full block bg-secondary-700 text-white hover:bg-white hover:text-secondary-700 transition-colors"
                    />
                )}
            </span>
        </div>
    );
}
export function RenewCard({ onClick, data }) {
    if (data.limitBy === 'lifetime') {
        return <LifeTimeCard onClick={onClick} data={data} />;
    }
    if (data.limitBy === 'ppu') {
        return <PPUCard onClick={onClick} data={data} />;
    }
    return <DurationCard onClick={onClick} data={data} />;
}

function LinkUpCard({ title, des, onClick, className }) {
    return (
        <div
            role="button"
            tabIndex={-1}
            onClick={onClick}
            className={`group w-full lg:w-[310px] min-h-[72px] flex flex-row rounded-xl bg-secondary-200 hover:bg-secondary p-3 transition-all ${className}`}
        >
            <div className="flex flex-col gap-8 justify-start items-start">
                <h4 className="text-lg font-medium text-secondary group-hover:text-white mt-2">
                    <span>{title}</span>
                </h4>
                <div className="text-sm font-normal text-primary-700 group-hover:text-primary-100">
                    <span>{des}</span>
                </div>
            </div>

            <button
                type="button"
                className="w-9 min-w-[36px] h-9 bg-secondary-700 group-hover:bg-secondary-700/50 rounded-lg p-1 cursor-pointer"
            >
                <img src={menuIcon.settingsWF} alt="" className="w-full h-full" />
            </button>
        </div>
    );
}

export default LinkUpCard;
